import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=10d298b0&scoped=true&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"
import style0 from "./RichText.vue?vue&type=style&index=0&id=10d298b0&prod&lang=scss&scoped=true&"
import style1 from "./RichText.vue?vue&type=style&index=1&id=10d298b0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d298b0",
  null
  
)

export default component.exports